import _ from 'lodash';
import pricingHelper from '../../helpers/pricingHelper';
import ganttViewModel from '$$ganttViewModel';
import helpers from './helpers';
import app from '$$app';
import constants from './constants';

class ColumnsBar {
  constructor() {
    this.ganttColumns = {};
    this.listViewColumns = {};
    this.listViewData = {};
  }

  initGanttColumns(allColumns, enabledColumns) {
    const customColumns = [];
    const standartColumns = [];
    const projectData = ganttViewModel.getActiveViewData() || {};

    _.each(allColumns, column => {
      if (column.isShowCheckbox && pricingHelper.checkPricingAccess(helpers.getPricingColName(column))) {
        // if (!(projectData.is_jira && column.name === 'creator')
        //   && !((!projectData.gantt_id && column.name === 'jira_key') || (projectData.gantt_id && !projectData.is_jira && column.name === 'jira_key'))) {
        //   const columnItem = helpers.prepareItemForBarMenu(column, enabledColumns);

        //   standartColumns.push(columnItem);
        // }

        if (projectData.is_jira && column.name === 'creator') {
          return;
        }

        if (!projectData.gantt_id && column.name === 'jira_key') {
          return;
        }

        if (projectData.gantt_id && !projectData.is_jira && column.name === 'jira_key') {
          return;
        }

        const columnItem = helpers.prepareItemForBarMenu(column, enabledColumns);

        standartColumns.push(columnItem);
      }

      if (column.isUserCustomColumn) {
        const customColumnItem = helpers.prepareItemForBarMenu(column, enabledColumns);

        customColumns.push(customColumnItem);
      }
    });

    const groupedStandartColumns = helpers.groupedStandartColumns(standartColumns);
    const enabledCustomColumns = customColumns.filter(col => col.enabled);
    const sortedDisabledCustomColumns = customColumns.filter(col => !col.enabled).sort((a, b) => a.value.localeCompare(b.value));

    this.ganttColumns = {
      standartColumns: groupedStandartColumns,
      customColumns: enabledCustomColumns.concat(sortedDisabledCustomColumns),
    };

    app.trigger('columnsBar:gantt:refresh');
  }

  reorderCustomColumns(columnsConfig) {
    const orderedColumns = [];

    columnsConfig.columnsOrder.forEach(id => {
      const customColumn = this.ganttColumns?.customColumns?.find(col => col.id === id);

      if (customColumn) {
        orderedColumns.push(customColumn);
      }
    });

    const enabledCustomColumns = orderedColumns.filter(col => col.enabled);
    const sortedDisabledCustomColumns = orderedColumns.filter(col => !col.enabled).sort((a, b) => a.value.localeCompare(b.value));

    this.ganttColumns.customColumns = enabledCustomColumns.concat(sortedDisabledCustomColumns);
  }

  disableColumnById(id) {
    const groupName = helpers.getColumnGroupNameById(id);

    if (groupName && groupName.length) {
      const standartColumn = this.ganttColumns.standartColumns[groupName].find(col => col.id === id);

      if (standartColumn) {
        const isDateColumn = (standartColumn.id === 'start_date' || standartColumn.id === 'end_date');
        const index = this.ganttColumns.standartColumns[groupName].indexOf(standartColumn);

        standartColumn.enabled = false;

        if (isDateColumn) {
          standartColumn.enabledOption = false;
        }

        this.ganttColumns.standartColumns[groupName].splice(index, 1, standartColumn);
      }
    } else {
      const customColumn = this.ganttColumns.customColumns.find(col => col.id === id);

      if (customColumn) {
        const index = this.ganttColumns.customColumns.indexOf(customColumn);

        customColumn.enabled = false;

        this.ganttColumns.customColumns.splice(index, 1, customColumn);

        const enabled = this.ganttColumns.customColumns.filter(c => c.enabled);
        const disabled = this.ganttColumns.customColumns
          .filter(c => !c.enabled)
          .sort((a, b) => a.value.localeCompare(b.value));

        this.ganttColumns.customColumns = [...enabled, ...disabled];
      }
    }
  }

  initListViewColumns(listViewData) {
    const columns = helpers.prepareListViewAllColumns(listViewData.listViewColumns);
    const enabledColumns = helpers.prepareListViewEnabledColumns(listViewData.config.columns);

    const customColumns = [];
    const standartColumns = [];

    columns.forEach(column => {
      if (!column.custom) {
        const columnItem = helpers.prepareItemForBarMenu(column, enabledColumns);

        standartColumns.push(columnItem);
      }

      if (column.custom) {
        const customColumnItem = helpers.prepareItemForBarMenu(column, enabledColumns);

        customColumns.push(customColumnItem);
      }
    });

    const groupedStandartColumns = helpers.groupedStandartColumns(standartColumns);
    const enabledCustomColumns = customColumns.filter(col => col.enabled);
    const sortedDisabledCustomColumns = customColumns.filter(col => !col.enabled).sort((a, b) => a.value.localeCompare(b.value));

    this.listViewData = listViewData;
    this.listViewColumns = {
      standartColumns: groupedStandartColumns,
      customColumns: enabledCustomColumns.concat(sortedDisabledCustomColumns),
    };

    app.trigger('columnsBar:listView:refresh');
  }

  changeCheckbox(payload, mode) {
    const { id, value, group } = payload;

    if (mode === 'gantt') {
      this.changeGanttColumns(id, value, { isAdvanced: false });
    }

    if (mode === 'list') {
      this.changeListViewColumns(id, value, group);
    }
  }

  changeGanttColumns(id, value, options) {
    const val = value ? 1 : 0;

    app.trigger('columnsBar:gantt:change', id, val, options);
  }

  changeListViewColumns(id, value, group) {
    const enabledCustomColumns = this.listViewColumns.customColumns.filter(col => col.enabled);
    const enabledStandartColumns = Object.values(this.listViewColumns.standartColumns).flat().filter(col => col.enabled);
    const advancedOptionsEnabled = enabledStandartColumns.filter(col => col.option).filter(col => col.enabledOption);

    let advancedIds = [];
    let selected = enabledStandartColumns.concat(enabledCustomColumns);

    if (advancedOptionsEnabled.length) {
      advancedIds = advancedOptionsEnabled.map(col => `${col.id}_extra`);
    }

    if (typeof id === 'string' && id.includes('_extra')) {
      if (advancedIds.some(extraId => extraId === id)) {
        advancedIds = advancedIds.filter(extraId => extraId !== id);
      } else {
        advancedIds.push(id);
      }

      let optionId;

      if (id.includes('start_date')) {
        optionId = 'start_date';
      }

      if (id.includes('end_date')) {
        optionId = 'end_date';
      }

      this.listViewColumns.standartColumns[group] = this.listViewColumns.standartColumns[group].map(col => {
        const column = { ...col };

        if (col.id === optionId) {
          column.enabledOption = value;
        }

        return column;
      });
    } else {
      if (selected.some(col => col.id === id)) {
        selected = selected.filter(col => col.id !== id);
      } else {
        const newEnabledColumn = { id };

        if (!constants.STANDART_COLUMNS.hasOwnProperty(id)) {
          newEnabledColumn.custom = true;
        }

        selected.push(newEnabledColumn);
      }

      if (constants.STANDART_COLUMNS.hasOwnProperty(id)) {
        this.listViewColumns.standartColumns[group] = this.listViewColumns.standartColumns[group].map(col => {
          const column = { ...col };

          if (col.id === id) {
            column.enabled = value;
          }

          return column;
        });
      } else {
        this.listViewColumns.customColumns = this.listViewColumns.customColumns.map(col => {
          const column = { ...col };

          if (col.id === id) {
            column.enabled = value;
          }

          return column;
        });
      }
    }

    const prepared = selected.map(sel => ({
      ...sel,
      property: sel.id,
    }));

    app.trigger('columnsBar:listView:change', {
      columns: prepared,
      extra: advancedIds,
    });
  }

  changeOptionCheckbox(payload, mode) {
    const { id, value, group } = payload;

    if (mode === 'gantt') {
      const val = value ? 1 : 0;

      this.changeGanttColumns(id, val, { isAdvanced: true });
    }

    if (mode === 'list') {
      const extraId = `${id}_extra`;

      this.changeListViewColumns(extraId, value, group);
    }
  }
}

const columnsBar = new ColumnsBar();

export default columnsBar;
